// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__37Rm2","title":"Accordion_title__JjK07","reveal":"Accordion_reveal__e0FfP","fade_in":"Accordion_fade_in__ND5ZZ"};